import ServiceCategory from "../models/ServiceCategory";

export default class BusinessUtils {
  public constructor() {}
  public static getCategeryServiceType(st: ServiceCategory): string {
    let serviceType: Array<string> = [];

    if (st.inCall) {
      serviceType.add("In-Call ");
    }

    if (st.outCall) {
      serviceType.add("Out-Call ");
    }

    if (st.teleCall) {
      serviceType.add("Tele-Call ");
    }

    return serviceType.join(", ");
  }
}
